import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as Editor from '../../../../assets/ckeditor';
import { HttpClient } from '@angular/common/http';
import * as d3 from 'd3';
import { MaskingService } from '@services/masking.service';
import { Subscription } from 'rxjs';
import { PanZoomConfig, PanZoomAPI, PanZoomModel, PanZoomConfigOptions } from 'ngx-panzoom';
import { ActivatedRoute, Router } from '@angular/router';
import * as cloneDeep from 'node_modules/lodash.clonedeep';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import { ColorPickerModule, ColorPickerService } from 'ngx-color-picker';
import { QuestionService } from '@services/question.service';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionSubTypeIdEnum, QuestionTypeIdEnum, ScoringTypeEnum } from '@configs/questions.config';
import Adapter from '../ckeditorAdapter';

@Component({
  selector: 'app-items-hotspot-multi-choice',
  templateUrl: './items-hotspot-multi-choice.component.html',
  styleUrls: ['./items-hotspot-multi-choice.component.scss']
})
export class ItemsHotspotMultiChoiceComponent implements OnInit, AfterViewInit {

  addQuestionForm: FormGroup;
  uploadFileForm: FormGroup;
  Editor: any = Editor;
  errorMsg;
  public uploadedFileNames = [];
  showQuestionError: boolean = false;
  selectedFile: File;

  @Input() position: { x: number, y: number };
  @Output() hotspotClicked = new EventEmitter<void>();

  @ViewChild('rectArea') rectArea!: ElementRef;

  public colorList = [
    { key: 'flame', value: '#e45a33', friendlyName: 'Flame' },
  ];

  public dragging = false;
  public drawing = false;
  public startPoint;
  public svg;
  public g;
  points = []
  // store coordiantes from API
  // public points = [
  //   [[430.4999789794932, 214.4999895263677], [503.9999753906262, 263.99998710937564], [536.9999737792982, 175.4999914306645]],  //polygon1
  //   [[446.9999781738292, 355.4999826416024], [473.99997685546987, 418.4999795654307], [515.9999748046887, 341.9999833007821]],  //polygon2
  // ];

  allPoints: any[] = []
  public color1: string = '#2889e9';
  public color = '#32bbbc8f';
  public history = [];
  public deletedHistory = [];
  public svgElement;
  public PanZoomConfig: PanZoomConfig = new PanZoomConfig({
    zoomLevels: 10,
    scalePerZoomLevel: 1.5,
    zoomStepDuration: 0.2,
    freeMouseWheel: false,
    invertMouseWheel: false,
    zoomToFitZoomLevelFactor: 0.9,
    dragMouseButton: 'right',
    initialZoomLevel: 1,
    zoomOnMouseWheel: false,
    zoomOnDoubleClick: false
  });
  private panZoomAPI: PanZoomAPI;
  public panzoomModel: PanZoomModel;
  private apiSubscription: Subscription;
  private modelChangedSubscription: Subscription;
  public layers;
  public loadedMask = false;
  public layerPoints = [];
  public localStorage = [];
  public previewShown = false;
  @ViewChild('artboard') artboard;
  public opacity: number = 0.8;
  @ViewChild('url') url;
  @Output() Layers;
  @Output() postCreated = new EventEmitter();
  private dimensions;
  deleteButtonClicked: boolean = false;
  imageUrl = '';
  newEvent;
  moreOptionForm: FormGroup;
  addNewOption: FormGroup;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  autoscoring: boolean;
  QuestionScoringType: any;
  QuestionOrientation: any;
  getscoringtype: any;
  display: boolean = true;
  listDisplay = true;
  undoHistory: string[][] = [];
  redoHistory: string[][] = [];
  deletedData = [];
  index = 0;
  errorMessage;
  uploadImgError;
  userForm: FormGroup;
  selectedOption: any;
  inputValues: number[] = [];
  correctPoint;
  itemuuId: any;
  apiData;
  getQuestionDisplay: string;
  scoreArray = [];
  isEditMode: boolean = false;
  questionId: string;
  selectionIndex;
  uploadBtn: boolean = false;
  ScoringTypeEnum = ScoringTypeEnum;
  scoringTypeId: any;
  editQuestionData: any;
  drawingArrow: boolean = false;
  deletecolor: boolean = false;
  hotspotColor = true;
  filetext: any;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;
  QuestionImages = []
  imageId: number = 1;
  constructor(public fb: FormBuilder, private http: HttpClient, private activatedRoute: ActivatedRoute, private maskSvc: MaskingService,
    private webErrorService: WebErrorService, public translate: TranslateService, private cpService: ColorPickerService,
    public questionService: QuestionService,
    private router: Router,
    private routerstate: ActivatedRoute,
    public itemservice: ItemService,
    private notificationServices: NotificationService,
    private cdr: ChangeDetectorRef) {

    this.addQuestionForm = new FormGroup({
      question: new FormControl(
        { value: '', disabled: false }, Validators.required
      )
    });

    this.uploadFileForm = this.fb.group({
      file: ['']
    })

    this.moreOptionForm = fb.group({
      hideRequired: this.hideRequiredControl,
      floatLabel: this.floatLabelControl,
      autoscore: new FormControl(true),
      scoringTypeMatch: ['false'],
      minimumScoreIfAttempt: [0, Validators.required],
      penaltyPoint: [''],
      questionDisplay: ['Vertical']
    });

    this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemuuId = data.id;
    });

    this.questionService.getQuestionScoringType().subscribe(d => { this.QuestionScoringType = d.data })
    this.questionService.getQuestionOrientation().subscribe(o => { this.QuestionOrientation = o.data })

    this.questionId = sessionStorage.getItem('questionuuId');
    if (!this.questionId) { this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId; }

    if (this.questionId) {
      // console.log('constructor called')
      this.isEditMode = true;
      this.questionService.getQuestion(this.itemuuId, this.questionId).subscribe(res => {
        console.log('get data', res)
        const hotspotData = res.data
        this.editQuestionData = res.data;
        this.addQuestionForm.controls['question'].setValue(res?.data?.questiondescription.description);
        this.moreOptionForm.setValue({
          hideRequired: this.hideRequiredControl,
          floatLabel: this.floatLabelControl,
          autoscore: res?.data?.autoScoring,
          scoringTypeMatch: res?.data?.scoringTypeExactMatch,
          minimumScoreIfAttempt: res?.data?.minScoreIfAttempt,
          penaltyPoint: res?.data?.penaltyPoint,
          questionDisplay: res?.data?.questiondisplayoptions
        });
        this.getscoringtype = String(res?.data?.scoringTypeExactMatch);
        this.getQuestionDisplay = String(res?.data?.questiondisplayoptions);
        this.newEvent = res.data?.correctPoints;
        this.imageUrl = hotspotData.hotspotMedia
        this.color = res?.data?.questiondescription.outLine
        this.color1 = res?.data?.questiondescription.inLine;
        this.hotspotColor = res?.data?.isRemoveHotspotColor;
        this.g = this.svg.select('g.drawPoly');
        this.ngOnInit()
      })
    }

  }

  ngOnInit(): void {
    const storage = Object.entries(localStorage);
    for (const item of storage) {
      if (item[0].includes('github')) {
        item[0] = item[0].match(/[\w-]+\.(png|jpg)/)[0].substring(0, 4);
        this.localStorage.push(item);
      }
    }

    this.apiSubscription = this.PanZoomConfig.api.subscribe((api: PanZoomAPI) => this.panZoomAPI = api);

    // get info about zoom level
    this.modelChangedSubscription = this.PanZoomConfig.modelChanged.subscribe((model: PanZoomModel) => {
      this.onModelChanged(model);
      this.panzoomModel = model;
      // it will get called on edit mode
      if (model.zoomLevel != null && this.editQuestionData != undefined && this.editQuestionData.options.length > 0) this.editQClosePolygon();
    });

    // this.dimensions = this.maskSvc.getDimensions();
    // // console.log(d3.select('.artboard').selectAll('svg'));
    // // d3.select('svg').remove();
    // this.svg = d3.select('.artboard').append('svg')
    //   .attr('background-size', this.dimensions.width + 'px ' + this.dimensions.height + 'px')
    //   .attr('background-repeat', 'no-repeat')
    //   .attr('height', this.dimensions.canvasHeight)
    //   .attr('width', this.dimensions.canvasWidth);

    // this.updateCanvas();
    // this.svg.style('background-image', `url(${this.imageUrl})`);
    // this.svg.style('background-image', `url('https://picsum.photos/200/300?grayscale')`);

    this.maskSvc.getMaskUrl().subscribe(url => {
      this.loadedMask = true;
      this.svg.selectAll('.existingMask').remove();
      const g = this.svg.append('g').attr('class', 'existingMask' + ' completePoly').attr('layerHidden', 'false')
        .attr('color', 'existingMask')
        .attr('opacity', 0.8)
        .attr('visibility', 'visible');
      g.append('svg:image')
        .attr('href', url)
        .attr('x', 43)
        .attr('y', 38);
    })
  }

  onModelChanged(model: PanZoomModel): void {
    if (this.artboard && model.zoomLevel >= 1) {
      this.svg.selectAll('circle').attr('r', 4 / (model.zoomLevel / 1.5));
      this.svg.selectAll('polyline').attr('stroke-width', 2 / (model.zoomLevel / 2));
      this.svg.selectAll('circle').attr('stroke-width', 1 / (model.zoomLevel / 2));
      this.svg.style('background-image', `url(${this.imageUrl})`);
    }
  }

  private updateCanvas(): void {
    // Set canvas dimensions in case it changed
    this.dimensions = this.maskSvc.getDimensions();
    if (this.dimensions) {
      this.svg = d3.select(this.artboard.nativeElement).select('svg')
        .attr('height', this.dimensions.canvasHeight)
        .attr('width', this.dimensions.canvasWidth);
      this.svg.style('background-size', this.dimensions.width + 'px ' + this.dimensions.height + 'px');
      this.svg.style('background-image', `url(${this.imageUrl})`);
      if (this.editQuestionData != undefined && this.editQuestionData.options.length > 0) this.editQClosePolygon();
    }
  }

  ngAfterViewInit(): void {
    this.maskSvc.setArtboard(this.artboard.nativeElement.innerHTML);
    this.svgElement = this.artboard.nativeElement.children[0];

    this.dimensions = this.maskSvc.getDimensions();

    this.svg = d3.select(this.artboard.nativeElement).append('svg')
      .attr('background-size', this.dimensions.width + 'px ' + this.dimensions.height + 'px')
      .attr('background-repeat', 'no-repeat')
      .attr('height', this.dimensions.canvasHeight)
      .attr('width', this.dimensions.canvasWidth);

    this.updateCanvas();
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMsg = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMsg = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMsg = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  saveQuestion() {
    this.allPoints.forEach((element, index) => {
      if (element.answerValid === true) {
        this.selectionIndex = element.answerValid
      }
    });
    let quesDescription = this.addQuestionForm.controls['question'].value;
    if (this.allPoints.length <= 1) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg2'), true, 'warn')
    } else if (quesDescription.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
    } else if (this.selectionIndex === undefined || null) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg4'), true, 'warn')
    } else if (this.allPoints.length > 0 && quesDescription.length !== 0 && this.selectionIndex !== undefined) {
      // console.log('call api')
      if (this.QuestionImages.length > 0) {
        this.QuestionImages.forEach(ele => {
          quesDescription = quesDescription.replace(ele.base64, ele.uniqueId)
          let startIndex = ele.base64.lastIndexOf('base64,');
          ele.base64 = ele.base64.substring(startIndex +7)
        })
      }

      const cpayload = {
        options: [],
        stems: [],
        questiondescription: {
          description: quesDescription,
          mediaURL: [],
          file_name: this.uploadedFileNames,
          outLine: this.color,
          inLine: this.color1
        },
        questionImages: this.QuestionImages,
        itemId: JSON.parse(sessionStorage.getItem('itemId')),
        autoScoring: this.moreOptionForm.controls['autoscore'].value,
        shuffleOption: false,
        correctPoints: this.newEvent,
        active: true,
        HotspotMedia: this.imageUrl,
        ansRenderCount: 0,
        IsRemoveHotspotColor: this.hotspotColor,
        questionOrder: 0,
        questionSubTypeId: QuestionSubTypeIdEnum.HotspotMultiChoice,
        questionTypeId: QuestionTypeIdEnum.Hotspot,
        allowCheckAnswer: false,
        questiondisplayoptions: this.moreOptionForm.controls['questionDisplay'].value,
        scoringTypeExactMatch: this.moreOptionForm.controls['scoringTypeMatch'].value,
        minScoreIfAttempt: this.moreOptionForm.controls['minimumScoreIfAttempt'].value,
        penaltyPoints: 0
      }

      this.allPoints.forEach((a, i) => {
        this.apiData = {
          answerDescription: {
            description: this.translate.instant('questions.typeOfQuestions.hotspotQuestion.hotspotLabel') + `${i + 1}`,
            mediaURL: [""],
            publicPoints: '',
          },
          answerValid: a.answerValid,
          arrangeOrder: i + 1,
          correctPoints: a.correctPoints,
          modified: a.modified,
          optionId: a.optionId,
          selected: false,
          styleid: 0
        }
        // if (a.id) this.apiData.id = a.id;
        if (a.id && a.modified) this.apiData.id = a.id;
        this.apiData.answerDescription.publicPoints = a.answerDescription == undefined ? a.map(element => element) : a.answerDescription.publicPoints.map(e => e)
        cpayload.options.push(this.apiData)
      });
      console.log(cpayload)
      if (this.isEditMode == false) {
        this.questionService.addQuestion(cpayload, this.itemuuId).subscribe(res => {
          if (res.success) {
            this.notificationServices.success(res?.message);
            // this.itemservice.questionCountUpdate.next(true);
            // this.questionService.reloadList.next(true);
            this.listDisplay = false;
            // this.back();
          }
        }, (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
      } else {
        this.questionService.updateHotspotQuestion(cpayload, this.itemuuId, this.questionId).subscribe(res => {
          if (res.success) {
            this.notificationServices.success(res?.message);
            // this.itemservice.questionCountUpdate.next(true);
            // this.questionService.reloadList.next(true);
            this.listDisplay = false;
            // this.back();
          }
        }, (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
      }
    }
  }

  back() {
    d3.select(this.artboard.nativeElement).selectAll('svg').remove()
    console.log(d3.select('.artboard').selectAll('svg').remove());
    this.postCreated.emit('false');
    this.display = false;
    this.allPoints = []
  }

  onFileSelected(event) {
    this.selectedFile = event.target.files[0]
    const fileSizeInMB = this.selectedFile.size / (1024 * 1024); // Convert bytes to MB
    // this.selectedFile.name ? this.uploadBtn = true : this.uploadBtn = false;
    if (fileSizeInMB > 100) {
      this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
      this.uploadImgError = '';
      this.selectedFile = null;
      this.svg.style('background-image', `url()`);
      this.imageUrl = ''
      this.allPoints = [];
      this.history = [];
      this.deletedHistory = [];
      this.svg.selectAll('g').remove();
    } else {
      let newFileName = this.selectedFile.name.replace(/\s+/g, '-');
      let newFile = new File([this.selectedFile], newFileName, { type: this.selectedFile.type });
      this.selectedFile = newFile;
      this.errorMessage = '';
      this.uploadImgError = '';
      this.onUpload();
    }
  }

  onUpload() {
    this.questionService.uploadImageApi(this.selectedFile, '').subscribe(res => {
      if (res.data) {
        this.imageUrl = res.data;
        this.svg.style('background-image', `url(${this.imageUrl})`);
        this.allPoints.forEach(element => {
          this.questionService.deleteOption(this.questionId, element.id).subscribe((data) => {});
        });
        this.allPoints = [];
        this.points = [];
        this.history = [];
        this.deletedHistory = [];
        this.filetext = ''
        this.svg.selectAll('g').remove();
      }
    }, (err) => {
      this.uploadImgError = err?.error?.message; //this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
      this.svg.style('background-image', `url()`);
      this.imageUrl = '';
      this.allPoints = [];
      this.history = [];
      this.deletedHistory = [];
      this.svg.selectAll('g').remove();
    })
  }

  addScore(value, event) {
    this.scoreArray = [];
    this.allPoints.forEach(element => {
      if (element.answerValid == true) {
        this.scoreArray.push(element.correctPoints)
      }
    });

    this.newEvent = this.scoreArray.reduce(add, 0);
    function add(accumulator, a) {
      return accumulator + a;
    }
  }

  private setLayers(): void {
    this.maskSvc.updateMask({ d3: this.svg, dom: this.artboard.nativeElement, loadedMask: this.loadedMask });
  }

  deleteLayerClick(e): void {
    if (e.target.tagName === 'polygon') {
      this.deleteFromOption(e.target);
      this.addToHistory(this.drawing, this.startPoint, this.g, this.points, 'deleted');
      e.target.parentNode.remove();

      this.allPoints = this.allPoints.filter(value => value.length !== 0);
      this.allPoints.forEach((points, i) => {
        this.svg.selectAll('g').nodes()[i].children[this.svg.selectAll('g').nodes()[i].children.length - 1].innerHTML = i + 1;
      })
      this.points.splice(0);
    } else if(e.target.tagName === 'circle') {
      this.deleteFromOption(e.target.parentNode.children[0]);
      this.addToHistory(this.drawing, this.startPoint, this.g, this.points, 'deleted');
      e.target.parentNode.remove();
      this.points.splice(0);
      this.allPoints = this.allPoints.filter(value => value.length !== 0);
      this.allPoints.forEach((points, i) => {
        this.svg.selectAll('g').nodes()[i].children[this.svg.selectAll('g').nodes()[i].children.length - 1].innerHTML = i + 1;
      })
    }
  }

  deleteFromOption(element): void {
    for (const e of element.animatedPoints) {
      this.allPoints.forEach((points, index) => {
        if (this.isEditMode) {
          if (points.answerDescription != undefined) {
            for (const p of points.answerDescription.publicPoints) {
              if (Math.trunc(e.x) == Math.trunc(p[0]) && Math.trunc(e.y) == Math.trunc(p[1])) {
                this.addToDeleteHistory(this.allPoints[index]);
                this.questionService.deleteOption(this.questionId, points.id).subscribe((data) => {});
                this.allPoints[index] = []
                this.allPoints = this.allPoints.filter(value => value.length !== 0);
              }
            }
          } else {
            for (const p of points) {
              if (Math.trunc(e.x) == Math.trunc(p[0]) && Math.trunc(e.y) == Math.trunc(p[1])) {
                this.addToDeleteHistory(this.allPoints[index]);
                this.allPoints[index] = []
                this.allPoints = this.allPoints.filter(value => value.length !== 0);
              }
            }
          }
        } else {
          for (const p of points) {
            if (Math.trunc(e.x) == Math.trunc(p[0]) && Math.trunc(e.y) == Math.trunc(p[1])) {
              this.addToDeleteHistory(this.allPoints[index]);
              this.allPoints[index] = []
            }
          }
        }
      });

      this.addScore('', '')
    }
  }

  // deleteFromToolTip(index) {
  //   this.allPoints.splice(index, 1)
  //   this.allPoints = this.allPoints.filter(value => value.length !== 0);
  // }

  public mouseUp(e) {
    this.svgElement = this.artboard.nativeElement.children[0];
    if (!this.drawing && this.deleteButtonClicked) {
      this.deleteLayerClick(e);
      return;
    }

    if (this.artboard.nativeElement.children[0].style.backgroundImage == 'url("")' || this.drawingArrow== false) return;

    if (this.g) {
      // if (this.points.length > 0) this.addToHistory(this.drawing, this.startPoint, this.g, this.points);
      this.addToHistory(this.drawing, this.startPoint, this.g, this.points);
    }
    this.g = this.svg.select('g.drawPoly');

    if (e.button !== 0) { return; }
    if (this.dragging) { return; }
    if (this.previewShown) { return; }

    this.startPoint = [(e.layerX - this.panzoomModel.pan.x) *
      (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)),
    (e.layerY - this.panzoomModel.pan.y) *
    (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth))];

    if (this.svg.select('g.drawPoly').empty()) {
      this.g = this.svg.append('g').attr('class', 'drawPoly');
      this.svg.selectAll('circle').attr('cursor', 'default');
    }

    if (e.toElement.tagName === 'circle' && this.points[0].length >= 3 && e.toElement.classList[0] == 'inProgressCircle1') {
      this.closePolygon();
      return;
    }
    if (this.points.length != 0) {
      this.points[0].push([(e.layerX - this.panzoomModel.pan.x) *
        (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)),
      (e.layerY - this.panzoomModel.pan.y) *
      (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth))]);
    }

    if (this.points.length == 0) {
      this.points.push([[(e.layerX - this.panzoomModel.pan.x) *
        (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)),
      (e.layerY - this.panzoomModel.pan.y) *
      (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth))]]);
    }

    this.svg.select('g.drawPoly').append('polyline').attr('points', this.points[0])
      .style('fill', 'none')
      .attr('stroke-width', 2 / (this.panzoomModel.zoomLevel / 2))
      .attr('stroke', '#000');
      const newCircle = this.svg.select('g.drawPoly').append('circle')
      .attr('cx', this.points[0][this.points[0].length - 1][0])
      .attr('cy', this.points[0][this.points[0].length - 1][1])
      .attr('r', 4 / (this.panzoomModel.zoomLevel / 1.5))
      .attr('stroke-width', 2 / (this.panzoomModel.zoomLevel / 2))
      .attr('fill', this.color)
      .attr('stroke', '#000')
      .attr('is-handle', 'true')
      .attr('class', 'inProgressCircle' + this.points[0].length)
      .attr('style', 'cursor:pointer');

      // ---if the class is not inProgressCircle1 then add css------
    if (this.points[0].length !== 1) {
      newCircle.attr('style', 'pointer-events:none;');
    }
  }

  // function is called on edit mode to drow polygon
  public editQClosePolygon(childPoly?: boolean) {
    this.svgElement = this.artboard.nativeElement.children[0];
    let child = '';
    let g;
    if (childPoly) {
      child = ' child';
    }
    this.svg.selectAll('circle').attr('cursor', 'move');
    this.svg.select('g.drawPoly').remove();
    this.editQuestionData.options.forEach(element => {
      element.modified = true;
    });
    this.allPoints = this.editQuestionData.options.sort((a, b) => a.optionId - b.optionId);
    for (const point of this.editQuestionData.options.sort((a, b) => a.optionId - b.optionId)) {
      g = this.svg.append('g').attr('class', this.color + ' completePoly' + child).attr('layerHidden', 'false')
        .attr('color', this.color)
        .attr('opacity', 0.8)
        .attr('visibility', 'visible');

      g.append('polygon')
        .attr('points', point.answerDescription.publicPoints)
        .attr('shape-rendering', 'crispEdges')
        .style('fill', this.color)
        .style('opacity', 0.8)
        .attr('stroke-width', '3')
        .attr('stroke', this.color1);

      for (const point1 of point.answerDescription.publicPoints) {
        const holder = this;
        g.selectAll('circles')
          .data([point1])
          .enter()
          .append('circle')
          .attr('cx', point1[0])
          .attr('cy', point1[1])
          .attr('r', 4 / this.panzoomModel.zoomLevel)
          .attr('stroke-width', 1 / (this.panzoomModel.zoomLevel / 2))
          .attr('fill', '#FDBC07')
          .attr('stroke', '#000')
          .attr('is-handle', 'true')
          .attr('class', 'dragCircle')
          .attr('cursor', 'move')
          .call(d3.drag()
            .on('drag', function () {
              holder.handleDrag(this);
            })
            .on('end', () => {
              this.dragging = false;
              this.addToHistory(this.drawing, this.startPoint, this.g, point.answerDescription.publicPoints);
            })
          );
      }

      g.append('circle').attr('points', point.answerDescription.publicPoints[0])
      .attr('cx', point.answerDescription.publicPoints[0][0])
      .attr('cy', point.answerDescription.publicPoints[0][1])
      .attr('fill', 'white')
      .attr('r', 15 / this.panzoomModel.zoomLevel)
      .attr('stroke', '#000')

      g.append('text').attr('points', point.answerDescription.publicPoints[0])
      .attr('x', point.answerDescription.publicPoints[0][0] - 7)
      .attr('y', point.answerDescription.publicPoints[0][1] + 10)
      .attr('fill', '#4B0082')
      .attr('font-size',25)
      .text(point.arrangeOrder);
    }

    // this.points.splice(0);
    this.drawing = false;
    // this.setLayers();
    // this.addToHistory(this.drawing, this.startPoint, this.g, this.points);
  }

  // function to draw polygon based on your points
  public closePolygon(childPoly?: boolean) {
    let child = '';
    let g;
    if (childPoly) {
      child = ' child';
    }
    this.svg.selectAll('circle').attr('cursor', 'move');
    this.svg.select('g.drawPoly').remove();

    for (const point of this.points) {
      g = this.svg.append('g').attr('class', this.color + ' completePoly' + child).attr('layerHidden', 'false')
        .attr('color', this.color)
        .attr('opacity', 0.8)
        .attr('visibility', 'visible');

      g.append('polygon')
        .attr('points', point)
        .attr('shape-rendering', 'crispEdges')
        .style('fill', this.color)
        .style('opacity', 0.8)
        .attr('stroke-width', '3')
        .attr('stroke', this.color1);

      if (point.length >= 3) {
        this.allPoints = [...this.allPoints, ...this.points]
        this.allPoints.forEach((ele, i) => {
          if (ele.answerValid == undefined) {
            ele.answerValid = ele.answerValid == undefined ? false : ele.answerValid;
            ele.optionId = (this.allPoints[i-1] != undefined && this.allPoints[i-1].optionId != undefined) ? this.allPoints[i-1].optionId + 1  : 1;
            ele.modified = false;
            ele.correctPoints = ele.correctPoints == undefined ? 0 : ele.correctPoints;
          }
        })
      }

      for (const point1 of point) {
        const holder = this;

        g.selectAll('circles')
          .data([point1])
          .enter()
          .append('circle')
          .attr('cx', point1[0])
          .attr('cy', point1[1])
          .attr('r', 4 / this.panzoomModel.zoomLevel)
          .attr('stroke-width', 1 / (this.panzoomModel.zoomLevel / 2))
          .attr('fill', '#FDBC07')
          .attr('stroke', '#000')
          .attr('is-handle', 'true')
          .attr('class', 'dragCircle')
          .attr('cursor', 'move')
          // .call(d3.drag()
          //   .on('drag', function () {
          //     holder.handleDrag(this);
          //   })
          //   .on('end', () => {
          //     this.dragging = false;
          //     this.addToHistory(this.drawing, this.startPoint, this.g, point);
          //   })
          // );
      }

      g.append('circle').attr('points', this.points[0][0])
      .attr('cx', this.points[0][0][0])
      .attr('cy', this.points[0][0][1])
      .attr('fill', 'white')
      .attr('r', 15 / this.panzoomModel.zoomLevel)
      .attr('stroke', '#000')

      g.append('text').attr('points', this.points[0][0])
      .attr('x', this.points[0][0][0] - 7)
      .attr('y', this.points[0][0][1] + 10)
      .attr('fill', '#4B0082')
      .attr('font-size',25)
      .text(this.allPoints.length);
    }

    this.drawing = false;
    // this.setLayers();
    this.history[0][5] = this.allPoints.length;
    // this.addToHistory(this.drawing, this.startPoint, this.g, [], this.allPoints.length);
    this.points.splice(0);
  }

  public enableDragging() {
    const holder = this;
    this.svg.selectAll('.dragCircle').call(d3.drag()
      .on('drag', function () {
        holder.handleDrag(this);
      })
      .on('end', () => {
        this.dragging = false;
        this.addToHistory(this.drawing, this.startPoint, this.g, this.points);
      })
    );
  }

  public mouseMove(e) {
    if (!this.drawing) { return; }
    const g = d3.select('g.drawPoly');
    if (e.target.tagName === 'line') { return; }
    if (e.target.className.baseVal === 'inProgressCircle') {
      g.select('line').remove();
      return;
    }
    g.select('line').remove();
    g.append('line')
      .attr('x1', this.startPoint[0])
      .attr('y1', this.startPoint[1])
      .attr('x2', (e.layerX - this.panzoomModel.pan.x) *
        (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)))
      .attr('y2', (e.layerY - this.panzoomModel.pan.y) *
        (1 / (this.artboard.nativeElement.getBoundingClientRect().width / this.artboard.nativeElement.offsetWidth)))
      .attr('stroke', '#53DBF3')
      .attr('stroke-width', 2 / (this.panzoomModel.zoomLevel * 1.3));
  }

  public addToHistory(drawing, startPoint, g, points, polycount?): void {
    if (this.svgElement != undefined) {
      const collection = this.svgElement.innerHTML;
      this.history.unshift([JSON.stringify(collection), JSON.stringify(drawing),
      JSON.stringify(startPoint), cloneDeep(g), JSON.stringify(points), polycount]);
    }
    // if (this.history.length > 15) {
    //   this.history.pop();
    // }
  }

  addToDeleteHistory(optionDetails) {
    this.deletedHistory.push([optionDetails])
    // this.deletedHistory.unshift([JSON.stringify(optionDetails)]);
  }

  public handleDrag(e) {
    // if (this.drawing) { return; }
    // const newPoints = [];
    // let circle;
    // this.dragging = true;
    // const poly = d3.select(e.parentNode).select('polygon');
    // const circles = d3.select(e.parentNode).selectAll('circle');
    // e.setAttribute('cy', d3.event.y);
    // e.setAttribute('cx', d3.event.x);
    // for (const circleGroup of circles._groups[0]) {
    //     circle = d3.select(circleGroup);
    //     newPoints.push([circle.attr('cx'), circle.attr('cy')]);
    // }
    // poly.attr('points', newPoints);
  }
  deletedd : boolean =  false;
  flag: any = 0;
  public undo(): void {
    this.svgElement = this.artboard.nativeElement.children[0];
    console.log('original history', this.history)
    if (this.history.length >= 0) {
      const deletedItem = this.history[0]
      if (this.history.length == 0) {
        this.svgElement.innerHTML = '';
        this.drawing = false;
        this.startPoint = [];
        this.g = [];
        this.points = [];
        this.history.shift();
        this.svg.select('g.drawPoly').remove();
      } else {
        // this.svgElement.innerHTML = this.history.length == 1 ? JSON.parse(this.history[0][0]) : JSON.parse(this.history[1][0]);
        // this.drawing = false;
        // this.startPoint = this.history.length == 1 ? (this.history[0][2] == undefined ? [] : JSON.parse(this.history[0][2])) : (this.history[1][2] == undefined ? [] : JSON.parse(this.history[1][2]));
        // this.g = this.history.length == 1 ? this.history[0][3] :  this.history[1][3];
        // this.points = this.history.length == 1 ? JSON.parse(this.history[0][4]) :  JSON.parse(this.history[1][4]);

        this.svgElement.innerHTML = JSON.parse(this.history[0][0]);
        this.drawing = false;
        this.startPoint = this.history[0][2] == undefined ? [] : JSON.parse(this.history[0][2]);
        this.g = this.history[0][3];
        this.points = JSON.parse(this.history[0][4]);

        if (this.history[0][5] != undefined && this.history[0][5] != 'deleted') this.deletedd = false;
        if (this.history[0][5] != undefined && this.history[0][5] == 'deleted' && this.deletedHistory.length > 0) {
          this.deletedHistory[this.deletedHistory.length - 1][0].modified = false;
          // this.allPoints.splice(this.deletedHistory[this.deletedHistory.length - 1][0].optionId, 0, this.deletedHistory[this.deletedHistory.length - 1][0])
          this.allPoints.push(this.deletedHistory[this.deletedHistory.length - 1][0]);
          this.deletedd = true;
          this.allPoints.sort((a, b) => a.optionId - b.optionId);
        }
        // if (this.flag == 1) this.flag = 2;
        // if (this.history[0][5] != undefined && this.history[0][5] != 'deleted' && this.deletedd != true) this.flag = 1;

        if (this.history[0][5] != undefined && this.history[0][5] != 'deleted' && this.deletedd != true) {
          this.allPoints.splice((this.allPoints.findIndex(item => item.optionId == this.history[0][5])), 1)
          // this.flag = 0;
        }

        this.history.shift();
        this.deletedHistory.splice(this.deletedHistory.length - 1, 1)
        this.addScore('', '')
        if (this.history.length == 0 && this.allPoints.length == 0) {
          this.svg.select('g.drawPoly').remove();
          this.svgElement.innerHTML = '';
          this.drawing = false;
          this.startPoint = [];
          this.g = [];
          this.points = [];
          this.history.shift();
        }
      }
      // Store the deleted item in another array for redo
      this.deletedData.push(deletedItem);
    }
    // Iterate over allPointsArray to find and remove the matching point
    for (let i = 0; i < this.allPoints.length; i++) {
      const points = this.allPoints[i];
      for (let j = 0; j < points.length; j++) {
        const pointString = points[j]
        if (pointString[0] === this.startPoint[0] && pointString[1] === this.startPoint[1]) {
          this.allPoints[i].splice(j, 1);
          break; // Exit the loop once the point is removed
        }
      }
    }
    // console.log('all points',this.allPoints)
    this.allPoints = this.allPoints.filter(value => value.length !== 0);
    this.enableDragging();
  }

  public redo(): void {
    this.index++;
    console.log('deleted', this.deletedData)
    console.log('history', this.history)
    this.history.unshift(...this.deletedData)
    // console.log(this.deletedData + 'after'+ this.history)
    if (this.history.length > 0) {
      this.svgElement.innerHTML = JSON.parse(this.history[this.index][0]);
      this.drawing = JSON.parse(this.history[this.index][1]);
      this.startPoint = JSON.parse(this.history[this.index][2]);
      this.g = this.history[this.index][3];
      this.points = JSON.parse(this.history[this.index][4]);
    }
  }


  public toFront(i: number) {
    this.svgElement.append(this.svgElement.children[i]);
  }

  public toBottom(i: number) {
    this.svgElement.prepend(this.svgElement.children[i]);
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code === 'KeyZ' && event.ctrlKey === true) { this.undo(); }
    if (event.code === 'Numpad0' || event.code === 'Digit0') { this.panZoomAPI.resetView() }
  }

  deleteShape(event) {
    this.drawingArrow  = false;
    this.deletecolor = true;
    this.deleteButtonClicked = event;
  }

  drawShape(event) {
    this.drawingArrow  = true;
    this.deletecolor = false;
    this.deleteButtonClicked = event;
  }

  undoShape() {
    this.undo();
  }

  redoShape() {

  }

  ZoomIn(event) {
    this.panZoomAPI.zoomIn();
  }

  ZoomOut(event) {
    this.panZoomAPI.zoomOut();
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg1'), true, 'warn')
      return false;
    } else {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.TrueOrFalse.errMsg1'), true, 'warn')
      return false;
    }
  }

  onCheckRadioOption(value, event) {
    if (value) {
      this.allPoints.forEach((element) => {
        if (
          element.optionId ==
          value.optionId
        ) {
          if (element.answerValid == false) {
            element.answerValid = true;
          } else {
            element.answerValid = false;
          }
          this.addScore(value, event);
        }
      });
    }
  }

  generateRadio(data) {
    data.forEach(element => {
      if (element === this.correctPoint) {
        console.log('print correct ans', element)
      }
    });
  }

  onChangeColor(color: string): void {
    this.color = color;
    this.svgElement = this.artboard.nativeElement.children[0];
    this.allPoints.forEach((points, index) => {
      this.svgElement.children[index].children[0].style.fill = color;
      this.svgElement.children[index].children[0].style.opacity = 0.8;
    });
  }

  onChangeBorderColor(color: string) {
    this.allPoints.forEach((points, index) => {
      this.svgElement.children[index].children[0].style.stroke = color;
      this.svgElement.children[index].children[0].style.strokeWidth = "3";
    });
  }

  replace2Decimal(event: any, o, type: any){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key;
    if(value == '.') value = "";
    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));

    if (type == 'options') o.correctPoints = parseFloat(value);
    if (type == 'minimumScore') {
      let num = value.substr(value.length - 1);
      if (num != '.' && value != '') this.moreOptionForm.controls.minimumScoreIfAttempt.setValue(parseFloat(value))
    }
  }

  validateInput(event, o?, type?) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,4}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]
    console.log('value',value)
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      if(type == 'options') o.correctPoints = parseFloat(inputElement.value );
      if(type == 'minimumScore') this.moreOptionForm.controls.minimumScoreIfAttempt.setValue(parseFloat(inputElement.value))
      if(beforeDecimal.length == 5 && afterDecimal.length > 1){
        inputElement.value = ''
        if(type == 'options') o.correctPoints = 0;
        if(type == 'minimumScore') this.moreOptionForm.controls.minimumScoreIfAttempt.setValue(0)
      }
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

}
